<template>
    <div class="invitation_container">
        <div class="menuLink_card">
            <img src="@/assets/agent/afiliado_2.png" alt="" height="195px">
            <div class="card_content">
                <div class="menuTitle">{{ $t('common.myLink') }}</div>
                <van-row class="copyLink_bar">
                    <van-col span="18" class="link">{{ copyUrl }}</van-col>
                    <van-col span="6" class="copy_btn" @click="copyHandle">
                        <img src="@/assets/agent/afiliado_botao_Copia.png" alt="" height="40px">
                    </van-col>
                </van-row>
                <div class="share_title">{{ $t('common.quickShare') }}</div>
                <div class="share_list">
                    <div class="share_item" v-for="item in shareList" :key="item.name" @click="goToShare">
                        <img :src="item.img" alt="">
                        <div>{{ $t(item.name) }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sub_Container">
            <GraphCard />
            <!-- recharge rewards tabel -->
            <div class="tabel_container">
                <van-row>
                    <van-col span="12" class="btn_column">
                        <div class="button_container" @click="setSelectedRechargeType(0)"
                            :style="{ opacity: selectedRechargeType == 1 ? '0.45' : '' }">
                            <img :src="require('@/assets/agent/quanxianzhuanyi_bai.png')" alt="">
                            <div class="btn_text">
                                {{ $t('agent.directRechargeCommision') }}
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12" class="btn_column">
                        <div class="button_container" @click="setSelectedRechargeType(1)"
                            :style="{ opacity: selectedRechargeType == 0 ? '0.45' : '' }">
                            <img :src="require('@/assets/agent/qun_bai.png')" alt="">
                            <div class="btn_text">
                                {{ $t('agent.cmultiveRechare') }}
                            </div>
                        </div>
                    </van-col>
                </van-row>
                <div class="tabel_content">
                    <div v-if="selectedRechargeType == 0">
                        <van-row class="tabel_hed">
                            <van-col span="10" class="head_alignemnet">{{ $t('common.level') }}</van-col>
                            <van-col span="2" class="head_alignemnet">
                                <div class="line"></div>
                            </van-col>
                            <van-col span="12" class="head_alignemnet">{{ $t('agent.giftRate') }}</van-col>
                        </van-row>
                        <van-row class="tabel_row" v-for="(item, index) in directRechargeList" :key="index" :style="{
                            backgroundColor: index % 2 === 1 ? ' rgba(255, 255, 255, 0.02)' : 'rgba(255, 255, 255, 0.04)'
                        }">
                            <van-col span="11" class="head_alignemnet">{{ item.levelName }}</van-col>
                            <van-col span="13" class="head_alignemnet">{{ item.value }}%</van-col>
                        </van-row>
                    </div>
                    <div v-if="selectedRechargeType == 1" class="container">
                        <van-tabs v-model:active="active" sticky :ellipsis="false" @click-tab="onClickTab">
                            <van-tab v-for="(item, index) in subTabList" :key="index" :title="item.limit" :name="index">
                                <van-row class="tabel_hed">
                                    <van-col span="10" class="head_alignemnet">{{ $t('common.level') }}</van-col>
                                    <van-col span="2" class="head_alignemnet">
                                        <div class="line"></div>
                                    </van-col>
                                    <van-col span="12" class="head_alignemnet">{{ $t('agent.giftRate') }}</van-col>
                                </van-row>
                                <van-row class="tabel_row" v-for="(subItme, index) in activeCumulativeRecharge?.levels"
                                    :key="index" :style="{
                                        backgroundColor: index % 2 === 1 ? ' rgba(255, 255, 255, 0.02)' : 'rgba(255, 255, 255, 0.04)'
                                    }">
                                    <van-col span="11" class="head_alignemnet">{{ subItme.levelName }}</van-col>
                                    <van-col span="13" class="head_alignemnet">{{ subItme.value }}%</van-col>
                                </van-row>
                            </van-tab>
                        </van-tabs>

                    </div>
                </div>
            </div>

            <!-- betting rewards table -->
            <div class="tabel_container">
                <van-row>
                    <van-col span="12" class="btn_column">
                        <div class="button_container" @click="setSelectedBetType(0)"
                            :style="{ opacity: selectedBetType == 1 ? '0.45' : '' }">
                            <img :src="require('@/assets/agent/quanxianzhuanyi_bai.png')" alt="">
                            <div class="btn_text">
                                {{ $t('agent.directBettingCommission') }}
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12" class="btn_column">
                        <div class="button_container" @click="setSelectedBetType(1)"
                            :style="{ opacity: selectedBetType == 0 ? '0.45' : '' }">
                            <img :src="require('@/assets/agent/quanxianzhuanyi_bai.png')" alt="">
                            <div class="btn_text">
                                {{ $t('agent.cumulativeBettingCommission') }}
                            </div>
                        </div>
                    </van-col>
                </van-row>
                <div class="tabel_content">
                    <div v-if="selectedBetType == 0">
                        <van-row class="tabel_hed">
                            <van-col span="10" class="head_alignemnet">{{ $t('common.level')
                                }}</van-col>
                            <van-col span="2" class="head_alignemnet">
                                <div class="line"></div>
                            </van-col>
                            <van-col span="12" class="head_alignemnet">{{ $t('agent.giftRate') }}</van-col>
                        </van-row>
                        <van-row class="tabel_row" v-for="(item, index) in bettingRewardList" :key="index" :style="{
                            backgroundColor: index % 2 === 1 ? ' rgba(255, 255, 255, 0.02)' : 'rgba(255, 255, 255, 0.04)'
                        }">
                            <van-col span="11" class="head_alignemnet">{{ item.levelName }}</van-col>
                            <van-col span="13" class="head_alignemnet">{{ item.value }}%</van-col>
                        </van-row>
                    </div>
                    <div v-if="selectedBetType == 1" class="container">
                        <van-tabs v-model:active="activeBet" sticky :ellipsis="false" @click-tab="onClickBetTab">
                            <van-tab v-for="(item, index) in betTabList" :key="index" :title="item.limit" :name="index">
                                <van-row class="tabel_hed">
                                    <van-col span="10" class="head_alignemnet">{{ $t('common.level')
                                    }}</van-col>
                                    <van-col span="2" class="head_alignemnet">
                                        <div class="line"></div>
                                    </van-col>
                                    <van-col span="12" class="head_alignemnet">{{ $t('agent.giftRate') }}</van-col>
                                </van-row>
                                <van-row class="tabel_row" v-for="(item, index) in activeCumulativeBet?.levels"
                                    :key="index" :style="{
                                        backgroundColor: index % 2 === 1 ? ' rgba(255, 255, 255, 0.02)' : 'rgba(255, 255, 255, 0.04)'
                                    }">
                                    <van-col span="11" class="head_alignemnet">{{ item.levelName }}</van-col>
                                    <van-col span="13" class="head_alignemnet">{{ item.value }}%</van-col>
                                </van-row>
                            </van-tab>
                        </van-tabs>
                    </div>
                </div>
            </div>

            <!-- Team Performance -->
            <div class="tabel_container">
                <div style="font-weight: bold;">{{ $t('agent.TeamPerformance') }}</div>
                <div class="tabel_content">
                    <van-row class="tabel_hed">
                        <van-col span="7" class="head_alignemnet">{{ $t('agent.minBet')
                        }}</van-col>
                        <van-col span="2" class="head_alignemnet">
                            <div class="line"></div>
                        </van-col>
                        <van-col span="6" class="head_alignemnet">{{ $t('agent.maxBet')
                        }}</van-col>
                        <van-col span="2" class="head_alignemnet">
                            <div class="line"></div>
                        </van-col>
                        <van-col span="7" class="head_alignemnet">{{ $t('agent.giftRate') }}</van-col>
                    </van-row>
                    <van-row class="tabel_row" v-for="(item, index) in teamPerformanaceList" :key="index" :style="{
                        backgroundColor: index % 2 === 1 ? ' rgba(255, 255, 255, 0.02)' : 'rgba(255, 255, 255, 0.04)'
                    }">
                        <van-col span="8" class="head_alignemnet">{{ item.min_bet }}</van-col>
                        <van-col span="8" class="head_alignemnet">{{ item.max_bet }}</van-col>
                        <van-col span="8" class="head_alignemnet">{{ item.rate }}%</van-col>
                    </van-row>
                </div>
            </div>

            <div class="bottom_text">
                <van-row style="padding-bottom: 10px;">
                    <van-col span="6" class="">
                        <div class="line1"></div>
                    </van-col>
                    <van-col span="12" class="title">
                        <div>{{ $t('common.activityTitle') }}</div>
                    </van-col>
                    <van-col span="6" class="">
                        <div class="line2"></div>
                    </van-col>
                </van-row>
                <div class="line_text" v-for="(item, index) in activityIntro" :key="index">
                    {{ item }}
                </div>
            </div>
        </div>


    </div>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { computed, onMounted, ref, defineEmits } from 'vue';
import GraphCard from './graphCard.vue';
import { useI18n } from 'vue-i18n';
import StatusPopup from '@/components/common/statusPopup.vue';
import { getActivityInformations, getAgentInfo } from '@/api/common';
import { useActivityStore } from '@/stores/activity';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { Share } from '@capacitor/share';
import { getActivityInfoFunc, getAgentInfoDataFunc, SHARE_LIST, BettingRewards, RechargeRewards, DirectRecharge, copyHandleFunc  } from '@/view/agent/supportScript'

const { t } = useI18n();
const activityStore = useActivityStore();
const activityList = computed(() => activityStore.activityList)
const rechargeRewardList = ref<RechargeRewards[]>([])
const bettingRewardList = ref<BettingRewards[]>([])
const eachRechargeReward = ref(0)
const eachBettingReward = ref(0)
const activityIntro = ref([])
const loadingRef = ref()
const shareList = ref(SHARE_LIST)
const subTabList = ref<any>([])
const betTabList = ref<any>([])
const active = ref(0);
const activeBet = ref(0);
const directRechargeList = ref<DirectRecharge[]>([])
const selectedRechargeType = ref(0)
const activeCumulativeRecharge = ref<any>({})
const activeCumulativeBet = ref<any>({})
const teamPerformanaceList = ref<any>([])
const selectedBetType = ref(0)
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const copyUrl = ref('')
const emits = defineEmits(['closePoup'])
const onClickTab = (active: any) => {
    activeCumulativeRecharge.value = subTabList.value[active.name]
}
const onClickBetTab = (active: any) => {
    activeCumulativeBet.value = betTabList.value[active.name]
}
const setSelectedRechargeType = (type: number) => {
    selectedRechargeType.value = type
}
const setSelectedBetType = (type: number) => {
    selectedBetType.value = type
}
const copyHandle = () => {
    copyHandleFunc(toastContent,isSuccess,copyUrl,statusRef,t)
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getActivityInfo = () => {
    getActivityInfoFunc(getActivityInformations, loadingRef, copyUrl, showError, emits)
}
const getAgentInfoData = () => {
    getAgentInfoDataFunc(
        getAgentInfo,
        loadingRef,
        directRechargeList,
        subTabList,
        activeCumulativeRecharge,
        bettingRewardList,
        betTabList,
        activeCumulativeBet,
        teamPerformanaceList,
        showError,
        emits
    )
}
const setData = () => {
    let agentActivity = activityList.value.find(
        (item: any) => item.name === 'agent_cash_back'
    ) || null;
    if (agentActivity) {
        let activityConfig = JSON.parse(agentActivity?.activityConfig)
        rechargeRewardList.value = activityConfig?.cumulative_recharge_config
        bettingRewardList.value = activityConfig?.cumulative_betting_config
        eachRechargeReward.value = activityConfig?.recharge_reward_percentage
        eachBettingReward.value = activityConfig?.betting_reward_percentage
        activityIntro.value = JSON.parse(agentActivity?.activityIntro)
    }

}
const goToShare = async () => {
    let shareLink = copyUrl.value //localStorage.getItem('shareLink')
    try {
       if (!shareLink) { return }
        await Share.share({
            text: shareLink,
        });
    } catch (error) {
       console.warn('Not supporting') 
    }
}
onMounted(() => {
    getAgentInfoData()
    getActivityInfo()
    setData()
    loadingRef.value.open()
})
</script>
<style scoped>
.invitation_container {
    padding: 15px 0 70px;
}

.invitation_container::-webkit-scrollbar {
    display: none;
}

.menuLink_card {
    position: relative;
}

.menuLink_card img {
    width: 100%;
}

.menuTitle {
    color: #FFFFFF;
    font-weight: 700;
    font-size: 15px;
    padding: 10px 0;
}

.copyLink_bar {
    padding: 5px 0;
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.65);
    background: rgba(0, 0, 0, 0.25);
    width: 100%;
}

.copy_btn img {
    width: 70px;
}

.copy_btn {
    padding-right: 5px;
    display: flex;
    justify-content: right;
    align-items: center;
}

.link {
    display: flex;
    align-items: center;
    padding-left: 10px;
}

.card_content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 0 40px;
    box-sizing: border-box;
}

.share_title {
    font-size: 14px;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    text-align: center;
    padding: 10px;
}

.share_list {
    font-size: 9px;
    color: rgba(255, 255, 255, 0.65);
    display: flex;
    flex-direction: row;
    max-width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    overflow-y: hidden;    
    scrollbar-width: none; 
    gap: 14px;
}

.share_list::-webkit-scrollbar {
    display: none;
}

.share_list img {
    width: 28px;
    padding-bottom: 5px;
}

.share_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.sub_Container {
    padding: 5px 20px;
}

.tabel_container {
    padding: 15px;
    background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.00) 100%);
    border: 1px solid rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(8px);
    border-radius: 10px;
    margin-top: 10px;
}

.button_container {
    border-radius: 10px;
    font-size: 13px;
    padding: 10px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000;
    background: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    height: 70%;
}

.button_container img {
    width: 18px;
    height: 18px;
    margin-right: 5px;
    filter: invert(100%);
}

.button_container>>>.van-button__content {
    justify-content: center !important;
}

.btn_text {
    display: flex;
    align-items: center;
}

.btn_column {
    padding: 2.5px;
}

.tabel_content {
    border-radius: 8px;
    overflow: hidden;
    margin-top: 10px;
}

.tabel_hed {
    background: rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.85);
    padding: 8px;
}

.head_alignemnet {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.line {
    width: 1px;
    height: 15px;
    background-color: rgba(255, 255, 255, 0.08);
}

.tabel_row {
    color: rgba(255, 255, 255, 0.85);
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    padding: 10px;
    font-size: 13px;
}

.bottom_text {
    padding: 25px 0;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
    line-height: 20px;
}

.amountText {
    padding: 15px 15px 0;
    color: rgba(255, 255, 255, 0.85);
}

.container>>>.van-tabs__nav {
    background: transparent;
    padding: 0 15px;
}

.container>>>.van-tab {
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.45);
    border-radius: 30px;
    font-size: 12px;
    margin: 5px;
    height: 35px;
    padding: 0 15px;
}

.container>>>.van-tab.van-tab--active {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #12151A;
    font-weight: 500;
}

.container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}
</style>